import { SECUNDARIO } from "src/styles/styles";
import { OpcionSelect } from "src/components/input/TextInput";

export enum Roles {
    ADMIN = 'ADMIN',
    GESTOR = 'GESTOR1',
}

export type Irol = {
    id: Roles;
    descripcion: string;
    peso: number;
    color: string;
    abreviatura?: string;
};

export const ROLES_DESCRIPCION: Irol[] = [
    { id: Roles.ADMIN, descripcion: 'Administrador', peso: 0, color: SECUNDARIO, abreviatura: 'SP' },
    { id: Roles.GESTOR, descripcion: 'Gestor', peso: 1, color: '#217bdb', abreviatura: 'AU' },
];

export const obtenerDescripcionRol = (rol: string | Irol): Irol | undefined=> {
    return ROLES_DESCRIPCION.find((r) => r.id === rol) || undefined;
}   

export const decodificarRol = (rol: string | Irol): string => {
    return ROLES_DESCRIPCION.find((r) => r.id === rol)?.descripcion || '';
}

export const obtenerColorRol = (rol: string | Irol): string => {
    return ROLES_DESCRIPCION.find((r) => r.id === rol)?.color || '';
}

export const obtenerCodigoRol = (rol: string): string => {
    return ROLES_DESCRIPCION.find((r) => r.id === rol)?.abreviatura || '';
}


export const opcionesRolesUnidad: OpcionSelect[] = [
    
];

export const opcionesRolesProyecto: OpcionSelect [] = [
    
];


